/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ICardFieldProps } from "../cards/CardField"
import TagCardField from "./TagCardField"

const CardFieldTags = (props: ICardFieldProps): JSX.Element => {
    const {field, value, section, i} = props 
    useEffect(() => { 
            addCSSClass(
                `landing-card-field-tags-${section.id + "-" + value?.id}`,
                `.landing-card-field-tags-${section.id + "-" + value?.id} {
                    
                } 
                `
            )
            return () => removeCSSClass(`landing-card-field-tags-${section.id + "-" + value?.id}`)
        }, [])
    
    const style = { 
        ...field.style, 
        ...value.style 
    }
    style.backgroundColor = undefined
    return <div 
        className={`landing-card-field landing-card-field-tags landing-card-field-tags-${section.id + "-" + value.id}`} 
        style={style} 
        data-card-field-id={i} 
        card-field-section-id={section.id}
    > 
        {
            Array.isArray(value.data) &&
            value.data.map((tag, i) => <TagCardField key={i} item={tag} />)
        }
    </div>
}
export default CardFieldTags